/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Skeleton, Empty } from 'antd'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import ConstituentAvatar from '../../components/Custom/ConstituentAvatar'
import ViewDetails from './modalDetails'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isViewDetailsShown: false
		}
	}

	render() {
		const { selectedConstituent, table_name } = this.props
		const { isViewDetailsShown } = this.state
		return (
			<Query 
				query={CONSTITUENT_BY_UID} 
				variables={{ constituent_uid: selectedConstituent.uid, table_name }}
				fetchPolicy='network-only'
			>
				{({ loading, error, data }) => {
					if (loading) return <Skeleton active/>
					if (error) return <Empty />

					let constituent = _.has(data,'barangayConstituentByUid') ? data.barangayConstituentByUid : {}
					//console.log('constituent', constituent)
					return (
						<React.Fragment>
							<legend>Details</legend>
							{
								table_name &&
								<div className="alert alert-icon alert-info alert-dismissible fade show" role="alert">
									<i className="mdi mdi-information mr-2"></i>
									<strong>Heads up! &nbsp;</strong>
									System detected that this person has {(constituent.certificate_count + 1)} time(s) request for this certificate.
								</div>
							}
							{
								(table_name && (constituent.complain_count > 0)) &&
                                <div className="alert alert-icon alert-warning alert-dismissible fade show" role="alert">
                                	<i className="mdi mdi-alert mr-2"></i>
                                	<strong>Complaint Warning!</strong> System detected that this person has {constituent.complain_count} complaint record(s) in the database.
                                </div>
							}
							{
								(table_name && (constituent.blotter_count > 0)) &&
                                <div className="alert alert-icon alert-warning alert-dismissible fade show" role="alert">
                                	<i className="mdi mdi-alert mr-2"></i>
                                	<strong>Blotter Warning!</strong> System detected that this person has {constituent.blotter_count} blotter record(s) in the database.
                                </div>
							}
							<Row style={{ marginTop: 30 }} type='flex' justify='center'>
								<ConstituentAvatar size={100}  constituent_uid={constituent.uid}/>
							</Row>
							<Row style={{ marginTop: 10, textAlign: 'center' }}>
								<h4>{constituent.first_name} {constituent.middle_name} {constituent.last_name}</h4><br />
								<a href='javascript:void(0)' onClick={() => this.setState({ isViewDetailsShown: true })}>View Details</a>
							</Row>
							{
								isViewDetailsShown &&
								<ViewDetails 
									table_name={table_name}
									constituent_uid={constituent.uid}
									visible={isViewDetailsShown}
									onCancel={() => this.setState({ isViewDetailsShown: false })}
								/>
							}
						</React.Fragment>
					)
				}}
			</Query>
		)
	}
}

const CONSTITUENT_BY_UID = gql`
    query barangayConstituentByUid($constituent_uid: String, $table_name: String) {
		barangayConstituentByUid(constituent_uid: $constituent_uid, table_name: $table_name)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
